import { FC, useRef, useState } from "react";
import styled, { CSSProperties } from "styled-components";
// import useSwipe from "../hooks/useSwipe";
import { useSwipe } from "../providers/SwipeProvider";

interface Props {
  direction: "right" | "left" | "up" | "down";
  breakpoint: string;
  style: CSSProperties;
}

const Block = styled.div<Props & { swiped: boolean }>`
  @media (max-width: ${({ breakpoint }) => breakpoint}) {
    min-width: 20rem;
    position: absolute;
    box-shadow: 0 0 32px black;
    left: ${({ direction }) => direction !== "left" && 0};
    right: ${({ direction }) => direction !== "right" && 0};
    bottom: ${({ direction }) => direction !== "down" && 0};
    top: ${({ direction }) => direction !== "up" && 0};
    transform: ${({ direction, swiped }) => {
      if (!swiped)
        switch (direction) {
          case "right":
            return "translate(-100%, 0)";
          case "left":
            return "translate(100%, 0)";
          case "up":
            return "translate(0, 100%)";
          case "down":
            return "translate(0, -100%)";
        }
      else return "translate(0, 0)";
    }};
    transition: transform 0.2s;
    z-index: 1;
  }
`;

const SwipeBlock: FC<Props> = ({ children, direction, breakpoint, style }) => {
  const [swiped, setSwiped] = useState(false);
  const symbol = useRef(Symbol("swipe-block"));

  const { swipedSymbol, setSwipedSymbol } = useSwipe(symbol.current, {
    swipeRight: () => {
      if (direction === "right") {
        swipeIn();
      }
      if (direction === "left") {
        swipeOut();
      }
    },
    swipeLeft: () => {
      if (direction === "left") {
        swipeIn();
      }
      if (direction === "right") {
        swipeOut();
      }
    },
    swipeUp: () => {
      if (direction === "up") {
        swipeIn();
      }
      if (direction === "down") {
        swipeOut();
      }
    },
    swipeDown: () => {
      if (direction === "down") {
        swipeIn();
      }
      if (direction === "up") {
        swipeOut();
      }
    },
  });

  function swipeIn() {
    if (swiped) return;
    setSwipedSymbol(symbol.current);
    setSwiped(true);
  }

  function swipeOut() {
    if (!swiped) return;
    setSwipedSymbol(null);
    setSwiped(false);
  }

  return (
    <Block
      direction={direction}
      breakpoint={breakpoint}
      swiped={swiped}
      style={style}
    >
      {children}
    </Block>
  );
};

export default SwipeBlock;
